<template>
    <dialog-base
        :maxWidth="480"
        :showDialog="showDialog"
        @close="handleCancel"
    >
        <dialog-header
            :title="translations.title"
            @close="handleCancel"
        />
        <dialog-body>
            <loading :loading="loading" />
            <confirm-dialog-body
                :message="actualMessage"
                :confirmMsg="names"
                showTextIcon
            />
        </dialog-body>
        <div class="d-flex flex-row align-center justify-end pa-4">
            <media-buttons
                :approvePrivilege="approvePrivilege === '1'"
                :publishPrivilege="publishPrivilege === '1'"
                :updateApprove="updateApprove"
                :updatePublish="updatePublish"
                :confirmText="translations.delete"
                @cycleUpdatePublish="cycleUpdatePublish"
                @cycleUpdateApprove="cycleUpdateApprove"
                @confirm="deleteMediaWrapper"
            />
            <v-btn class="ml-1" @click="handleCancel">
                {{ translations.no }}
            </v-btn>
        </div>
    </dialog-base>
</template>

<script>
    import ModalHeader from '../common/modal/modal-header.vue'
    import { caseInsensitiveSort } from '../../../utility'
    import toaster from "../../common/toaster";
    import MediaButtons from "./components/publish-buttons.vue";
    import Loading from "../../common/loading.vue";
    import DialogBase from "../../dialog/components/dialog-base.vue";
    import DialogBody from "../../dialog/components/dialog-body.vue";
    import DialogHeader from "../../dialog/components/dialog-header.vue";
    import ConfirmDialogBody from "../../dialog/confirm-dialog-body.vue";

    export default {
        components: {ConfirmDialogBody, DialogHeader, DialogBody, DialogBase, Loading, MediaButtons, ModalHeader },
        props: {
            approvePrivilege: String,
            publishPrivilege: String,
        },
        data: function () {
            return {
                showDialog: false,
                loading: false,
                multi: false,
                mediaNames: [],
                mediaIDs: [],
                updatePublish: 0,
                updateApprove: -1,
            }
        },
        computed: {
            translations() {
                return {
                    title: Lang.langGet("Delete media"),
                    warningSingle: Lang.langGet("Do you really want to delete this media?"),
                    warningMulti: Lang.langGet("Do you really want to delete all selected media?"),
                    no: Lang.langGet("No"),
                    delete: Lang.langGet("Delete"),
                    deleteSuccess: Lang.langGet("Media was deleted successfully."),
                    deleteFail: Lang.langGet("Failed to delete media!"),
                }
            },
            sortedMediaNames() {
                return this.mediaNames.sort(caseInsensitiveSort)
            },
            /** @type {String} */
            actualMessage() {
                return this.multi ? this.translations.warningMulti : this.translations.warningSingle;
            },
            names() {
                return this.sortedMediaNames.join(', ');
            }
        },
        methods: {
            handleCancel() {
                this.showDialog = false;
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
                if (this.publishPrivilege && this.approvePrivilege) {
                    this.updatePublish = parseInt(localStorage.getItem("mediapool-publish-" + Laravel.activeProject) ?? 1);
                }
                if (this.approvePrivilege) {
                    this.updateApprove = parseInt(localStorage.getItem("mediapool-approve-" + Laravel.activeProject) ?? 1);
                }
            },
            deleteMediaWrapper: function (approve=0, publish=0) {
                let data = {
                    approve: approve,
                    publish: publish
                };

                if (data.publish && !localStorage.getItem("mediapool-autopublish-confirm-" + Laravel.activeProject)) {
                    EaseEventBus.fire('showAutopublishWarning', {data: data, type: 'mediapool', task: 'Delete', id: 'delete-media'});
                } else {
                    this.deleteMedia(data);
                }
            },
            deleteMedia: function (data) {
                this.loading = true;

                axios.post('/content/mediapool/delete', {
                    id: this.mediaIDs,
                    approve: data.approve,
                    publish: data.publish
                }).then(() => {
                    toaster.success(this.translations.deleteSuccess);
                    EaseEventBus.fire('updateMedialist');
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.translations.deleteFail);
                }).finally(() => {
                    this.loading = false;
                    this.showDialog = false;
                });
            },
            cycleUpdatePublish: function () {
                this.updatePublish = (parseInt(this.updatePublish) + 1) % 2 || 0;
                localStorage.setItem("mediapool-publish-" + Laravel.activeProject, this.updatePublish);
            },
            cycleUpdateApprove: function () {
                this.updateApprove = (parseInt(this.updateApprove) + 1) % 2 || 0;
                this.updateApprove = this.updateApprove === 1 ? -1 : this.updateApprove;
                localStorage.setItem("mediapool-approve-" + Laravel.activeProject, this.updateApprove);
            }
        },
        mounted() {
            EaseEventBus.listen('deleteMedia', (mediaArray) => {
                this.reset();

                if(mediaArray == null) return;
                if(!Array.isArray(mediaArray)) {
                    mediaArray = [mediaArray];
                }
                this.multi = mediaArray.length > 1;
                mediaArray.forEach(media => {
                    this.mediaNames.push(`${media.name}.${media.file_extension}`);
                    this.mediaIDs.push(media.id);
                })
                this.showDialog = true;
            })

            EaseEventBus.listen('updateProceed', (data) => {
                if (data.type === 'mediapool' && data.task === 'Delete' && data.id === 'delete-media') {
                    if (data.proceed) {
                        this.deleteMedia(data.data);
                    }
                }
            });
        }
    }
</script>
